<!--  -->
<template>
  <div class="dease_box">
    <div
      v-for="item,index in list"
      :key="index"
      class="card"
      @click="chooser(item)"
    >
      <p class="demonstration">{{ item.description }}</p>
      <div class="el-image">
        <img :src="item.img" class="elawe" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import { acawraccountlist } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      platformId: null,
      type: null,
      list: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(sendplatformId, type) {
      console.log('send', sendplatformId)
      this.platformId = sendplatformId
      this.type = type
      this.getlistr()
    },
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformId,
        activityType: this.type
      })
      this.list = data.data.theme
      console.log('data', data)
    },
    chooser(val) {
      console.log('val', val)
      this.$emit('callbacktemp', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.card{
    margin-bottom: 10px;
    border: 1px solid #eee;
    width: 334px;
    margin-right: 10px;
}
.demonstration{
      text-align: center;
    cursor: pointer;
    box-sizing: border-box;
}
.el-image{
    cursor: pointer;
    display: inherit;
}
.elawe{
  width: 100%;
  height: 100%;
}
.dease_box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /* justify-content: center; */
  height: 680px;
  overflow: hidden;
  overflow-y:scroll
}
</style>
